// src/components/storefronts/RingsTabContent.js

import React from 'react';
import StorefrontRingGrid from '../ui/2-organisms/StorefrontRingGrid/StorefrontRingGrid';
import styles from './RingsTabContent.module.css';

/**
 * A "dumb" presentational component that displays a grid of rings.
 * It receives the fully sorted list of rings from its parent.
 *
 * @param {object} props
 * @param {Array<object>} props.rings - The array of jeweller's rings to display.
 * @param {Function} props.onRingClick - Callback for when a ring is clicked.
 */
const RingsTabContent = ({ rings, onRingClick }) => {
  return (
    <div className={styles.wrapper}>
      {rings && rings.length > 0 ? (
        <StorefrontRingGrid 
          rings={rings} 
          onRingClick={onRingClick} 
        />
      ) : (
        <p className={styles.emptyText}>
          This jeweller hasn't added any rings to their gallery yet.
        </p>
      )}
    </div>
  );
};

export default RingsTabContent;